import { render } from "./userCards.vue?vue&type=template&id=2bf09311"
import script from "./userCards.vue?vue&type=script&lang=js"
export * from "./userCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__